import { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  Fade,
  FormGroup,
  FormLabel,
  Grid,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { IsMobile } from "utils/is-mobile";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import CloseIcon from "@mui/icons-material/Close";
import {
  AddCircleOutline,
  NoteAltOutlined,
  TaskAlt,
  HighlightOff,
  KeyboardDoubleArrowRight,
} from "@mui/icons-material";
import ScrollBar from "react-perfect-scrollbar";

const CONFIG = [
  { value: "CNPJ", label: "CNPJ", xs: 3 },
  { value: "Empresa", label: "Empresa", xs: 5 },
  { value: "CriadoPor", label: "Criado Por", xs: 4 },
];

export default function ModalVizualizarSolicitacao({
  solicitacao,
  handleClose,
}) {
  const [searching, setSearching] = useState(false);
  const [details, setDetails] = useState([]);
  const [steps, setSteps] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const snakebar = useSnackbar();
  const isMobile = IsMobile();

  const handleSearchDetails = async () => {
    setSearching(true);

    try {
      const response = await Api.get(
        "list-request-management-reason",
        "trocasDevolucoes",
        "?idSolicitacao=" + solicitacao.IdSolicitacao,
        true
      );
      const result = response?.Result;
      setDetails(result);

      if (result?.HistoricoAlteracoes) {
        const chronologicalHistory = [...result.HistoricoAlteracoes].reverse();

        const mappedSteps = chronologicalHistory.map((item) => {
          let description = "";
          let icon = null;

          if (item.DescricaoAlteracao === "Solicitação criada") {
            description = "Solicitação cadastrada";
            icon = <AddCircleOutline color="primary" fontSize="medium" />;
          } else if (item.DescricaoAlteracao === "Solicitação encerrada") {
            if (solicitacao.StatusSolicitacao === "APROVADA") {
              description = "Solicitação Aprovada";
              icon = <TaskAlt sx={{ color: "#4caf50" }} fontSize="medium" />;
            } else {
              description = "Solicitação Rejeitada";
              icon = <HighlightOff color="error" fontSize="medium" />;
            }
          } else {
            description = `Solicitação alterada por ${item.NomeUsuario}`;
            icon = <NoteAltOutlined color="action" fontSize="medium" />;
          }

          return {
            date: item.DataAlteracao,
            description: description,
            icon: icon,
          };
        });
        setSteps(mappedSteps);
      }
    } catch (error) {
      snakebar.error(
        "Erro ao buscar detalhes da solicitação de devolução: " + error.message
      );
      console.error("Error fetching details:", error);
    } finally {
      setSearching(false);
    }
  };

  useEffect(() => {
    handleSearchDetails();
  }, []);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open
      onClose={() => handleClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      style={{
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Fade in={true}>
        <div
          style={{
            backgroundColor: "#FFF",
            padding: "20px",
            borderRadius: 8,
            width: "90%",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="1rem"
          >
            <Typography variant="body2">
              Detalhes da Solicitacao de Devolucão {solicitacao?.IdSolicitacao}{" "}
              - {solicitacao?.StatusSolicitacao}
            </Typography>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: isMobile ? 0 : "1rem",
                cursor: "pointer",
              }}
              onClick={() => handleClose()}
            >
              <Typography variant="caption">Fechar</Typography>
              <CloseIcon
                onClick={() => handleClose()}
                style={{ marginLeft: "0.5rem" }}
              />
            </Box>
          </Box>

          {searching ? (
            <Box>
              <Typography>Carregando detalhes...</Typography>
            </Box>
          ) : (
            <Box>
              <Grid container alignItems="center">
                {CONFIG.map((config, index) => (
                  <Grid item xs={isMobile ? 12 : config.xs} key={index}>
                    <FormGroup
                      style={{
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: "center",
                        gap: "0.5rem",
                        margin: 0,
                      }}
                    >
                      <FormLabel>{config.label}:</FormLabel>
                      <Typography
                        variant="body2"
                        style={{ marginBottom: "0.5rem" }}
                      >
                        {config.value === "CNPJ"
                          ? MaskAndValid.maskCNPJ(details?.[config.value] || "")
                          : details?.[config.value]}
                      </Typography>
                    </FormGroup>
                  </Grid>
                ))}
              </Grid>

              {steps.length > 0 && (
                <ScrollBar>
                  <Grid
                    container
                    alignItems="center"
                    style={{ margin: "2rem 0", flexWrap: "nowrap" }}
                  >
                    {steps.map((step, index) => (
                      <>
                        {index > 0 && <KeyboardDoubleArrowRight />}
                        <Grid
                          item
                          alignItems="center"
                          key={index}
                          style={{ width: "200px", padding: "0 1rem" }}
                        >
                          {step.icon}
                          <Typography variant="caption">
                            {MaskAndValid.formattDateBR(step.date)}
                          </Typography>
                          <Typography variant="caption" align="center">
                            {step.description}
                          </Typography>
                        </Grid>
                      </>
                    ))}
                  </Grid>
                </ScrollBar>
              )}

              <TableContainer
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                }}
              >
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  style={{ backgroundColor: "#f5f5f5" }}
                >
                  <Grid item xs={6}>
                    <Typography
                      variant="body2"
                      style={{
                        width: "100%",
                        padding: "0.5rem 0.5rem 0.5rem 2rem",
                        fontWeight: "bold",
                      }}
                    >
                      Histórico de Alterações
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Box style={{ padding: "0.5rem 0.5rem 0 0" }}>
                      <input
                        type="text"
                        placeholder="Pesquisar"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "0.5rem",
                          marginBottom: "0.5rem",
                          fontSize: "0.75rem",
                          border: "1px solid #ccc",
                          borderRadius: 4,
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
                <Table>
                  <TableHead>
                    <TableRow style={{ borderBottom: "1px solid #ddd" }}>
                      <TableCell>Data de Alteração</TableCell>
                      <TableCell>Alterado por</TableCell>
                      <TableCell align="center">Cod Produto</TableCell>
                      <TableCell>Descrição</TableCell>
                      <TableCell align="center">Qtd Devolvida</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {details?.HistoricoAlteracoes?.filter((change) => {
                      if (!searchTerm) return true;
                      const code = String(
                        change?.IdProduto || ""
                      ).toLowerCase();
                      const desc = String(
                        change?.DescricaoAlteracao || ""
                      ).toLowerCase();
                      return (
                        code.includes(searchTerm.toLowerCase()) ||
                        desc.includes(searchTerm.toLowerCase())
                      );
                    }).map((change, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell>
                            {MaskAndValid.formattDateBR(change.DataAlteracao)}
                          </TableCell>
                          <TableCell>{change?.NomeUsuario}</TableCell>
                          <TableCell align="center">
                            {change?.IdProduto}
                          </TableCell>
                          <TableCell>{change?.DescricaoAlteracao}</TableCell>
                          <TableCell align="center">
                            {change?.Quantidade}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </div>
      </Fade>
    </Modal>
  );
}
